import React from "react";

import {
  Typography, Card, CardActionArea, CardContent, CardActions, Divider,
} from '@mui/material';

export default function EmailLogsCard(props) {
  return (
    <>
      <Card
        style={styles.card}
      >
        <CardActions >
          <div style={styles.cardHeader}>
            <Typography variant='h6' style={styles.name}>Logs de E-mail</Typography>
          </div>
        </CardActions >
        <Divider />
        <CardActionArea onClick={props.click}>
          <CardContent style={styles.cardContent}>
            <div style={styles.infosContainer}>
              <div style={styles.info}>
                <Typography>Visualizar logs de e-mails enviado</Typography>
              </div>
            </div>
          </CardContent>
        </CardActionArea>
      </Card>
    </>
  )
}

const styles = {
  card: {
    width: 375,
    margin: 10,
  },
  cardHeader: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  name: {
    margin: '0 10px',
    width: '85%',
  },
  link: {
    display: 'flex',
    alignItems: 'center',
  },
  cardContent: {
    display: 'flex',
    alignItems: "center"
  },
  avatar: {
    width: 100,
    height: 100,
  },
  infosContainer: {
    marginLeft: 10,
  },
  info: {
    display: 'flex',
    alignItems: 'center',
  }
}
